import React from 'react';
import { Helmet } from 'react-helmet';
import { awcg_domain, awcg_domain_u1 } from '../../utils';
import { AnyLogo } from '../../components/AnyLogo';

const Logo = () => <AnyLogo height={32} />;

const Undeveloped = () => {
  const subject = `Enquiring for ${awcg_domain_u1}`;
  const mailto = `mailto:info@any-domains.uk?subject=${encodeURIComponent(subject)}`;

  return (
    <>
      <Helmet>
        <title>{awcg_domain_u1} | Awaiting Development</title>
        <meta name="robots" content="noindex" />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      </Helmet>
      <style>{`
        .aw-orphan{margin:0;padding:0;box-sizing:border-box;font-family:Georgia,'Times New Roman',serif;color:#111;background:#fff;height:100vh;display:flex;flex-direction:column}
        .aw-orphan *,.aw-orphan *::before,.aw-orphan *::after{box-sizing:border-box;margin:0;padding:0}
        .aw-orphan-header{padding:1.5rem 2.5rem;display:flex;align-items:center}
        .aw-orphan-body{flex:1;display:flex;align-items:center;justify-content:center;padding:2.5rem;background:#000}
        .aw-orphan-card{max-width:600px;width:100%;display:flex;flex-direction:column;align-items:center;text-align:center}
        .aw-orphan-domain{font-size:clamp(2rem,6vw,3.25rem);font-weight:400;color:#fff;letter-spacing:.02em;margin-bottom:2rem;word-break:break-word}
        .aw-orphan-divider{width:50px;height:1px;background:#444;margin-bottom:2rem}
        .aw-orphan-text{font-size:clamp(.9rem,1.3vw,1.05rem);line-height:1.9;color:#999;font-weight:400;margin-bottom:1.25rem}
        .aw-orphan-text strong{color:#ccc;font-weight:400;font-style:italic}
        .aw-orphan-contact{font-size:clamp(.9rem,1.3vw,1.05rem);line-height:1.9;color:#999;font-weight:400;margin-bottom:2.5rem}
        .aw-orphan-contact a{color:#fff;text-decoration:none;border-bottom:1px solid #555;transition:border-color .2s}
        .aw-orphan-contact a:hover{border-color:#fff}
        .aw-orphan-btn{display:block;padding:.85rem 3rem;border:1px solid #fff;color:#fff;text-decoration:none;font-family:Georgia,'Times New Roman',serif;font-size:.9rem;letter-spacing:.1em;text-transform:uppercase;transition:background .25s,color .25s}
        .aw-orphan-btn:hover{background:#fff;color:#000}
        .aw-orphan-footer{padding:1rem 2.5rem;font-size:.75rem;color:#aaa;text-align:center;border-top:1px solid #eee;font-family:-apple-system,system-ui,sans-serif}
        @media(max-width:600px){.aw-orphan-header{padding:1rem 1.25rem}.aw-orphan-body{padding:2rem 1.5rem}}
      `}</style>
      <div className="aw-orphan">
        <header className="aw-orphan-header">
          <Logo />
        </header>
        <main className="aw-orphan-body">
          <div className="aw-orphan-card">
            <h1 className="aw-orphan-domain">{awcg_domain || awcg_domain_u1}</h1>
            <div className="aw-orphan-divider" />
            <p className="aw-orphan-text">
              This domain was registered by <strong>ANY Web Ltd</strong> and is awaiting development.
            </p>
            <p className="aw-orphan-contact">
              Interested in owning or leasing this domain &mdash; or in a joint venture?<br />
              Contact <a href="mailto:info@any-domains.uk">info@any-domains.uk</a>
            </p>
            <a href={mailto} className="aw-orphan-btn">Enquire</a>
          </div>
        </main>
        <footer className="aw-orphan-footer">
          &copy; {new Date().getFullYear()} ANY Web Ltd
        </footer>
      </div>
    </>
  );
};

export default Undeveloped;
